module.exports = __webpack_public_path__ + "KaTeX_Caligraphic-Bold.b452e2f5.woff";